import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { LanguageKey } from '../../enums/language.enum';
import { LanguageService } from '../../services/language.service';


@Component({
    templateUrl: 'language-switch-modal.component.html',
    styleUrls: [
        './../../../../../styles.scss',
        './language-switch-modal.component.scss'
    ],
    encapsulation: ViewEncapsulation.ShadowDom
})

export class LanguageSwitchModalComponent implements OnInit {
    @Input() selectedLanguage!: LanguageKey;
    @Output() selectedLanguageChanged = new EventEmitter<LanguageKey>();

    constructor(
        private activeModal: BsModalRef,
        private languageService: LanguageService
    ) { }

    ngOnInit() { }

    isCurrentLanguage(langCode: string): boolean {
        return this.languageService.isCurrentLanguage(langCode as LanguageKey);
    }

    selectLanguage(langCode: LanguageKey | string) {
        this.selectedLanguage = langCode as LanguageKey;
        this.selectedLanguageChanged.emit(this.selectedLanguage);
        this.close();
    }

    close() {
        this.activeModal.hide();
    }
}